import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { Space, Tooltip } from 'antd';
import { TOUR_STORIES } from '../../../../constants/define/translation';
import { TourStoryType } from '../../../../types/tourStory';
import { btnActive } from '../../../../styles';
import { IconImageBlack, IconPlayBlack } from '../../../../assets';
import { SwitchCustom } from '../../../atoms';

interface ActionsColumnProps {
  record: TourStoryType;
  handleChangeSwitchVideo: Function;
}

export default React.memo((props: ActionsColumnProps) => {
  const { t } = useTranslation(TOUR_STORIES);
  const { record, handleChangeSwitchVideo } = props;
  const type = record?.type ? record.type : null;

  return (
    <StyledContainer>
      <Space size="small">
        {record.type ? (
          <div>{type === 'VIDEO' ? <IconPlayBlack /> : <IconImageBlack />}</div>
        ) : (
          <Tooltip title={record?.disabled ? t('table.tooltip.active') : t('table.tooltip.inactive')}>
            <SwitchCustom record={record} handleChangeSwitchVideo={handleChangeSwitchVideo} />
          </Tooltip>
        )}
      </Space>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  ${btnActive}
`;
